import { render, staticRenderFns } from "./applyAftSale.vue?vue&type=template&id=2c58e214&scoped=true&"
import script from "./applyAftSale.vue?vue&type=script&lang=js&"
export * from "./applyAftSale.vue?vue&type=script&lang=js&"
import style0 from "./applyAftSale.vue?vue&type=style&index=0&id=2c58e214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58e214",
  null
  
)

export default component.exports